// redux/api/Wallet/WalletApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const walletApi = createApi({
  reducerPath: "walletApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://idiag.vaccrm.com/VACRELOPOS/API/",
  }),
  tagTypes: ["Wallet"],
  endpoints: (builder) => ({
    getWalletHistory: builder.query({
      query: ({ phoneNumber }) => ({
        url: `history.php?phone_number=${phoneNumber}`,
        method: "GET",
      }),
      providesTags: ["Wallet"],
      transformResponse: (response) => {
        // Handle cases where earning/redeem might be strings (error messages)
        const earning = Array.isArray(response.earning) ? response.earning : [];
        const redeem = Array.isArray(response.redeem) ? response.redeem : [];

        return {
          earning,
          redeem,
          total_points: response.total_points || {
            phone_number: "",
            total_earning: "0",
            total_redeem: "0.00",
            remaining_points: 0,
          },
        };
      },
    }),
  }),
});

export const { useGetWalletHistoryQuery } = walletApi;
